import React, { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { FlexComponent } from "components/templates";
import { ItemCounter } from "components/molecules";
import { BorderInputs } from "components/templates";
import { NubeskIcons } from "components/atoms";
import sleep from "_utils/async/sleep";

const prefix = "t-task-search-panel";

const TaskSearchPanel = ({
  counterName,
  disabled,
  qty,
  total,
  placeholder,
  onSearch,
  useAction
}) => {
  const [searchValue, setSearchValue] = useState("");
  const [focus, setFocus] = useState(false);

  const classForComponent = classNames(prefix, { "is-focused": focus });

  const handleSearchChange = (value) => {
    setSearchValue(value);
    if (onSearch) {
      onSearch(value, useAction);
    }
  };

  const handleClearSearch = () => {
    setSearchValue("");
    if (onSearch) {
      onSearch("", useAction);
    }
  };

  return (
    <FlexComponent>
      <ItemCounter
        qty={qty}
        total={total}
        counterName={counterName}
      />
      <div
        className={classForComponent}
        onFocus={() => setFocus(true)}
        onBlur={() => sleep(100).then(() => setFocus(false))}
      >
        <BorderInputs>
          <NubeskIcons icon="search" className={`${prefix}__icon`} />
          <input
            className={`${prefix}__input`}
            disabled={disabled || false}
            placeholder={placeholder}
            value={searchValue}
            onBlur={() => sleep(100).then(() => setFocus(false))}
            onChange={(e) => {
              handleSearchChange(e.target.value);
              setFocus(true);
            }}
            onMouseEnter={() => setFocus(true)}
          />
          {searchValue && (
            <NubeskIcons
              icon="times"
              className={`${prefix}__clear`}
              onClick={handleClearSearch}
            />
          )}
        </BorderInputs>
      </div>
    </FlexComponent>
  );
};

TaskSearchPanel.propTypes = {
  counterName: PropTypes.string,
  disabled: PropTypes.bool,
  qty: PropTypes.number,
  total: PropTypes.number,
  placeholder: PropTypes.string,
  onSearch: PropTypes.func,
  useAction: PropTypes.bool
};

TaskSearchPanel.defaultProps = {
  counterName: "",
  disabled: false,
  qty: 0,
  total: 0,
  placeholder: "",
  onSearch: null,
  useAction: false
};

export default TaskSearchPanel;
